import { planningAPI } from "../../axios";

export const actions = {

    //PlanningApiResource
    GetPlanningApiResources(context, data) {
        return planningAPI.get(`PlanningApiResource/${data.apiId}/${data.budgetId}`);
    },
    GetPlanningApiResourcesByApi(context, data) {
        return planningAPI.get(`PlanningApiResource/PlanningApi/${data}`);
    },
    GetSinglePlanningApiResource(context, data) {
        return planningAPI.get(`PlanningApiResource/${data}`);
    },
    UpdatePlanningApiResource(context, data) {
        return planningAPI.put(`PlanningApiResource/${data.id}`, data);
    },
    DeletePlanningApiResource(context, data) {
        return planningAPI.delete(`PlanningApiResource/${data}`);
    },
    CreatePlanningApiResource(context, data) {
        return planningAPI.post(`PlanningApiResource`, data);
    },
    GetSimplePlanningApiResources(context, data) {
        return planningAPI.get(`PlanningApiResource/Simple/FinanceTemplateBudgetItem/${data}`);
    },
    GetAllPlanningApiResources(context, data) {
        return planningAPI.get(`PlanningApiResource/FinanceTemplateBudgetItem/${data}`);
    },
    MovePlanningApiResource(context, data) {
        return planningAPI.post(`PlanningApiResource/Move/${data.id}/${data.planningApiId}`);
    },
    TransferPlanningApiResource(context, data) {
        return planningAPI.post(`PlanningApiResource/Transfer/${data.id}/${data.transferFund}`, data.ids);
    },
    SetFSPlanningApiResource(context, data) {
        return planningAPI.post(`PlanningApiResource/SetFundSource/${data.fundSourceId}`, data.ids);
    }
}